import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";

export function useEventTags(orgId: string): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();

  return useQuery({
    queryKey: ["orgEventTags", orgId],
    queryFn: ({ signal }) => {
      return events.getTagsForOrg({
        abortSignal: signal,
        resourceOwnerId: orgId,
      });
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
  });
}
